import { FC } from "react";

interface RemoveIconProps {
    className: string;
    size?: number;
    onClick: () => void;
    role: string;
    tabIndex?: number;
}

export const RemoveIcon: FC<RemoveIconProps> = ({ className, size = 16, onClick, role, tabIndex = -1 }) => (
    <svg role={role} onClick={onClick} className={className} tabIndex={tabIndex} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
        <mask id="mask0_30_1843" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width={size} height={size}>
            <path d="M15.1998 15.9993C15.0718 15.9993 14.9509 15.9494 14.8606 15.8585L7.99982 8.99835L1.13902 15.8585C1.04814 15.9494 0.927824 15.9993 0.799824 15.9993C0.671824 15.9993 0.550864 15.9494 0.460624 15.8585C0.273744 15.6716 0.273744 15.367 0.460624 15.1795L7.32142 8.31867L0.460624 1.45851C0.369744 1.36827 0.319824 1.24731 0.319824 1.11931C0.319824 0.991312 0.369744 0.870352 0.460624 0.780112C0.550864 0.689232 0.671824 0.639312 0.799824 0.639312C0.927824 0.639312 1.04878 0.689232 1.13902 0.780112L7.99982 7.64027L14.8606 0.779472C14.9515 0.688592 15.0718 0.638672 15.1998 0.638672C15.3278 0.638672 15.4488 0.688592 15.539 0.779472C15.6299 0.870352 15.6798 0.991312 15.6798 1.11931C15.6798 1.24731 15.6299 1.36827 15.539 1.45851L8.67822 8.31931L15.539 15.1801C15.7259 15.367 15.7259 15.6716 15.539 15.8592C15.4488 15.9494 15.3278 15.9993 15.1998 15.9993Z" fill="white" />
        </mask>
        <g mask="url(#mask0_30_1843)">
            <rect width={size} height={size} fill="#0077FF" />
        </g>
    </svg>
)

